// Utility methods
const Utils = {
  defer(fn: () => void) {
    window.setTimeout(() => fn(), 0)
  },
}

export default Utils
